import { useNavigate } from 'react-router-dom'

const modulos = [
  { to: '/inventario', titulo: 'Inventario', descripcion: 'Consultar existencias y movimientos', color: 'bg-blue-500' },
  { to: '/recepciones', titulo: 'Recepciones', descripcion: 'Registrar entrada de mercancía', color: 'bg-emerald-500' },
  { to: '/surtido', titulo: 'Surtido', descripcion: 'Picking y packing', color: 'bg-amber-500' },
  { to: '/embarques', titulo: 'Embarques', descripcion: 'Preparar pedidos para despacho', color: 'bg-rose-500' },
  { to: '/rutas', titulo: 'Rutas', descripcion: 'Transporte y entregas', color: 'bg-indigo-500' },
  { to: '/reportes', titulo: 'Reportes', descripcion: 'KPIs y ocupación', color: 'bg-violet-500' },
]

export default function Dashboard() {
  return (
    <div className="anima-entrada">
      <header className="mb-8">
        <h2 className="text-3xl font-extrabold tracking-tight text-slate-900 dark:text-slate-100">Panel de control</h2>
        <p className="mt-2 text-slate-500 dark:text-slate-400">Administra los procesos logísticos desde un solo lugar.</p>
      </header>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {modulos.map((modulo) => (
          <Card key={modulo.to} {...modulo} />
        ))}
      </div>
    </div>
  )
}

function Card({
  to,
  titulo,
  descripcion,
  color,
}: {
  to: string
  titulo: string
  descripcion: string
  color: string
}) {
  const navigate = useNavigate()
  return (
    <div
      onClick={() => navigate(to)}
      className="group relative flex h-full flex-col rounded-2xl bg-white p-6 shadow-sm ring-1 ring-slate-200 transition-all duration-200 hover:-translate-y-1 hover:shadow-lg dark:bg-slate-800 dark:ring-slate-700 dark:hover:shadow-slate-900/40 cursor-pointer overflow-hidden"
    >
      <div className={`absolute left-0 top-0 h-full w-1.5 ${color}`} />
      <div className="mb-3 flex items-center justify-between">
        <h3 className="text-lg font-semibold text-slate-800 group-hover:text-slate-900 dark:text-slate-100 dark:group-hover:text-white">{titulo}</h3>
        <span className="text-xl text-slate-300 transition group-hover:text-slate-500 dark:text-slate-500 dark:group-hover:text-slate-300">→</span>
      </div>
      <p className="text-sm leading-relaxed text-slate-600 dark:text-slate-400">{descripcion}</p>
    </div>
  )
}
